let map;
let allMarkers = [];
const lclang = document.getElementById('js-data').dataset.lclang;
function initMap() {
    const mapElement = document.getElementById("map");

    if (!mapElement) {
        console.error("Map element is not defined.");
        return;
    }

    map = new google.maps.Map(mapElement, {
        center: { lat: 47.0, lng: 28.8 }, // или твои координаты
        zoom: 8,
    });

    initStoreMarkers();
}

function showStore(storeId) {
    allMarkers.forEach(marker => marker.setMap(null));

    const input = document.querySelector(`input[name="vacancy[store_id]"][value="${storeId}"]`);
    if (!input) return;

    const coords = input.dataset.coords.split(',');
    const lat = parseFloat(coords[0]);
    const lng = parseFloat(coords[1]);

    const selectedMarker = new google.maps.Marker({
        position: { lat, lng },
        map: map,
    });

    allMarkers.forEach(marker => marker.setMap(map));

    const markersToShow = allMarkers.filter(m => m !== selectedMarker);
    markersToShow.push(selectedMarker);

    const bounds = new google.maps.LatLngBounds();
    markersToShow.forEach(marker => {
        bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);

    google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        if (map.getZoom() > 15) {
            map.setZoom(15);
        }
    });

    $.post(`/${lclang}/ajax/get_store_info/`, { id: storeId }, function (data) {
        $('.city-block-scroll').html(data.html);
        document.querySelector('.drop-stores .btn').classList.remove('uk-form-danger');
    }, 'json').fail(function (jqXHR, textStatus, errorThrown) {
        console.error('Ошибка загрузки информации:', textStatus, errorThrown);
    });
}





function showSingleStoreIfOnlyOne() {
    const inputs = document.querySelectorAll('input[name="vacancy[store_id]"]');
    if (inputs.length === 1) {
        const input = inputs[0];
        const storeId = input.value;
        input.checked = true;
        showStore(storeId);
    }
}

function initStoreMarkers() {
    document.querySelectorAll('input[name="vacancy[store_id]"]').forEach(input => {
        const coords = input.dataset.coords.split(',');
        const lat = parseFloat(coords[0]);
        const lng = parseFloat(coords[1]);

        const marker = new google.maps.Marker({
            position: { lat, lng },
            map: map,
            storeId: input.value,
        });

        marker.addListener('click', () => {
            const input = document.querySelector(`input[name="vacancy[store_id]"][value="${marker.storeId}"]`);
            const nameSpan = document.querySelector('.drop-stores .name');
            if (!input) return;
            input.checked = true;
            showStore(marker.storeId);
            const label = input.parentNode.textContent.trim();
            nameSpan.textContent = label;
        });

        // allMarkers.push(marker);
    });

    document.querySelectorAll('input[name="vacancy[store_id]"]').forEach(input => {
        input.addEventListener('change', function () {
            showStore(this.value);
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    showSingleStoreIfOnlyOne();
    const radios = document.querySelectorAll('input[name="vacancy[store_id]"]');
    const nameSpan = document.querySelector('.drop-stores .name');
    const drop = UIkit.drop(document.querySelector('.drop-stores .uk-drop'));
    const searchInput = document.querySelector('.input-search');
    const listItems = document.querySelectorAll('.uk-dropdown-nav li');
    const form = document.querySelector('.vacancy-form');

    radios.forEach(radio => {
        radio.addEventListener('change', function () {
            const label = this.parentNode.textContent.trim();
            nameSpan.textContent = label;
            drop.hide(0);
        });
    });

    if (searchInput) {
        searchInput.addEventListener('input', function () {
            const filter = this.value.toLowerCase();

            listItems.forEach(li => {
                const text = li.textContent.toLowerCase();
                li.style.display = text.includes(filter) ? '' : 'none';
            });
        });
    }

    form.addEventListener('submit', function (e) {
        const checked = document.querySelector('input[name="vacancy[store_id]"]:checked');
        if (!checked) {
            e.preventDefault();
            drop.show();
            document.querySelector('.drop-stores .btn').classList.add('uk-form-danger');
        } else {
            document.querySelector('.block-form .btn-submit').classList.add('loading');
        }
    });
});

document.getElementById('fl1').addEventListener('change', function () {
    const fileName = this.files.length > 0 ? this.files[0].name : 'Файл не выбран';
    document.getElementById('file-name').textContent = fileName;
    document.querySelector('#fl1').classList.remove('uk-form-danger');

});